export default "__VITE_ASSET__Dt4um$7X__"